/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CalculateComparisonFuelModel } from '../models/CalculateComparisonFuelModel';
import type { CalculateMinDTO } from '../models/CalculateMinDTO';
import type { CalculateMinModel } from '../models/CalculateMinModel';
import type { CalculateServiceQuotaPaymentInput } from '../models/CalculateServiceQuotaPaymentInput';
import type { ComparisonFuelModel } from '../models/ComparisonFuelModel';
import type { FinanceTypeEnum } from '../models/FinanceTypeEnum';
import type { FinDataModel } from '../models/FinDataModel';
import type { FinPropDictionaries } from '../models/FinPropDictionaries';
import type { InitComparisonFuelInput } from '../models/InitComparisonFuelInput';
import type { ProgramDTO } from '../models/ProgramDTO';
import type { ServicePlanCalculate } from '../models/ServicePlanCalculate';
import type { ShortTermForecastResponse } from '../models/ShortTermForecastResponse';
import type { UpdateRfvRequest } from '../models/UpdateRfvRequest';
import type { UsedResudalValueRequest } from '../models/UsedResudalValueRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinanceService {

  /**
   * @param price 
   * @param basePrice 
   * @param discount 
   * @param optionsPrice 
   * @param apr 
   * @param initialRental 
   * @param selectedType
 *
 * 1 = HP
 *
 * 2 = PCP
 *
 * 3 = CS0
 *
 * 5 = x4x4
 *
 * 6 = PCPZero
 *
 * 7 = FL
 *
 * 9 = BCH
   * @param capCode 
   * @param isNew 
   * @param isVan 
   * @param isHoliday 
   * @param regDate 
   * @param maxVehicleAgeContract 
   * @param rfv 
   * @param skipRequestRfv 
   * @param deposit 
   * @param term 
   * @param miles 
   * @returns CalculateMinDTO Success
   * @throws ApiError
   */
  public static getCalculate(
price?: number,
basePrice?: number,
discount?: number,
optionsPrice?: number,
apr?: number,
initialRental?: number,
selectedType?: FinanceTypeEnum,
capCode?: string,
isNew?: boolean,
isVan?: boolean,
isHoliday?: boolean,
regDate?: string,
maxVehicleAgeContract?: number,
rfv?: number,
skipRequestRfv?: boolean,
deposit?: number,
term?: number,
miles?: number,
): CancelablePromise<CalculateMinDTO> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Calculate',
      query: {
        'Price': price,
        'BasePrice': basePrice,
        'Discount': discount,
        'OptionsPrice': optionsPrice,
        'Apr': apr,
        'InitialRental': initialRental,
        'SelectedType': selectedType,
        'CapCode': capCode,
        'IsNew': isNew,
        'IsVan': isVan,
        'IsHoliday': isHoliday,
        'RegDate': regDate,
        'MaxVehicleAgeContract': maxVehicleAgeContract,
        'Rfv': rfv,
        'SkipRequestRfv': skipRequestRfv,
        'Deposit': deposit,
        'Term': term,
        'Miles': miles,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param isNew 
   * @param varClass 
   * @returns ProgramDTO Success
   * @throws ApiError
   */
  public static getGetPrograms(
isNew?: boolean,
varClass?: string,
): CancelablePromise<Array<ProgramDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetPrograms',
      query: {
        'isNew': isNew,
        'varClass': varClass,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param isNew 
   * @param varClassCd 
   * @param price 
   * @param model 
   * @param capCode 
   * @param trimStyleId 
   * @returns FinDataModel Success
   * @throws ApiError
   */
  public static getGetFinanceProgram(
isNew?: boolean,
varClassCd?: string,
price?: number,
model?: string,
capCode?: string,
trimStyleId?: number,
): CancelablePromise<Array<FinDataModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFinanceProgram',
      query: {
        'isNew': isNew,
        'varClassCd': varClassCd,
        'price': price,
        'model': model,
        'capCode': capCode,
        'trimStyleId': trimStyleId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns ProgramDTO Success
   * @throws ApiError
   */
  public static getGetProgramLenders(): CancelablePromise<Array<ProgramDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetProgramLenders',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param vehicleId 
   * @param lenderId 
   * @returns ProgramDTO Success
   * @throws ApiError
   */
  public static getGetFinancePrograms(
vehicleId?: number,
lenderId?: number,
): CancelablePromise<Array<ProgramDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetFinancePrograms',
      query: {
        'vehicleId': vehicleId,
        'lenderId': lenderId,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns CalculateMinDTO Success
   * @throws ApiError
   */
  public static postCalculateBatch(
requestBody?: Record<string, CalculateMinModel>,
): CancelablePromise<Record<string, CalculateMinDTO>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CalculateBatch',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns ServicePlanCalculate Success
   * @throws ApiError
   */
  public static postCalculateServicePlanPayment(
requestBody?: CalculateServiceQuotaPaymentInput,
): CancelablePromise<ServicePlanCalculate> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/CalculateServicePlanPayment',
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param co2 
   * @param fueltypeId 
   * @param dateRegNo 
   * @param isVan 
   * @returns number Success
   * @throws ApiError
   */
  public static getGetCo2TaxCost(
co2?: number,
fueltypeId?: number,
dateRegNo?: string,
isVan?: boolean,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/GetCo2TaxCost',
      query: {
        'co2': co2,
        'fueltypeId': fueltypeId,
        'dateRegNo': dateRegNo,
        'isVan': isVan,
      },
    });
  }

  /**
   * @param co2 
   * @param fueltypeId 
   * @param date 
   * @param engineRange 
   * @returns number Success
   * @throws ApiError
   */
  public static getCo2Percent(
co2?: number,
fueltypeId?: number,
date?: string,
engineRange?: number,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/co2-percent',
      query: {
        'co2': co2,
        'fueltypeId': fueltypeId,
        'date': date,
        'engineRange': engineRange,
      },
    });
  }

  /**
   * @param id 
   * @returns ProgramDTO Success
   * @throws ApiError
   */
  public static getFinanceProgramsStock(
id: number,
): CancelablePromise<Array<ProgramDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance/programs/stock/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param id 
   * @returns FinDataModel Success
   * @throws ApiError
   */
  public static getFinanceProgramsVariant(
id: number,
): CancelablePromise<Array<FinDataModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance/programs/variant/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param capCode 
   * @param term 
   * @param annualMileage 
   * @param isVan 
   * @returns number Success
   * @throws ApiError
   */
  public static getFinanceLookupsRfvNew(
capCode?: string,
term?: number,
annualMileage?: number,
isVan?: boolean,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance/lookups/rfv-new',
      query: {
        'capCode': capCode,
        'term': term,
        'annualMileage': annualMileage,
        'isVan': isVan,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postFinanceLookupsRfvUsed(
requestBody?: Array<UsedResudalValueRequest>,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance/lookups/rfv-used',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param used 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postFinanceLookupsRfvSantander(
used?: boolean,
requestBody?: Array<UpdateRfvRequest>,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance/lookups/rfv-santander',
      query: {
        'used': used,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static putFinanceUpdateSantanderPrograms(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/finance/update-santander-programs',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @returns FinPropDictionaries Success
   * @throws ApiError
   */
  public static getFinanceProposalDictionary(): CancelablePromise<FinPropDictionaries> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance/proposal/dictionary',
    });
  }

  /**
   * @returns any Success
   * @throws ApiError
   */
  public static postFinanceCalculationsMonthlyPayment(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance/calculations/monthly-payment',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param capId 
   * @param mileage 
   * @param monthFrom 
   * @param monthTo 
   * @param valuationDate 
   * @returns ShortTermForecastResponse Success
   * @throws ApiError
   */
  public static getFinanceLookupsShortTermForecast(
capId: number,
mileage: number,
monthFrom: number,
monthTo: number,
valuationDate?: string,
): CancelablePromise<ShortTermForecastResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance/lookups/short-term-forecast',
      query: {
        'CapId': capId,
        'ValuationDate': valuationDate,
        'Mileage': mileage,
        'MonthFrom': monthFrom,
        'MonthTo': monthTo,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param comparisonId 
   * @param partialCalculate 
   * @returns CalculateComparisonFuelModel Success
   * @throws ApiError
   */
  public static getFinanceComparisonFuelCalculate(
comparisonId?: number,
partialCalculate: boolean = false,
): CancelablePromise<Array<CalculateComparisonFuelModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/finance/comparison/fuel/calculate',
      query: {
        'comparisonId': comparisonId,
        'partialCalculate': partialCalculate,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns ComparisonFuelModel Success
   * @throws ApiError
   */
  public static postFinanceComparisonFuelInit(
requestBody?: InitComparisonFuelInput,
): CancelablePromise<ComparisonFuelModel> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/finance/comparison/fuel/init',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
      },
    });
  }

  /**
   * @param comparisonVehicleId 
   * @param consumption 
   * @returns any Success
   * @throws ApiError
   */
  public static putFinanceComparisonFuelConsumption(
comparisonVehicleId?: number,
consumption?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/finance/comparison/fuel/consumption',
      query: {
        'comparisonVehicleId': comparisonVehicleId,
        'consumption': consumption,
      },
      errors: {
        400: `Bad Request`,
      },
    });
  }

}
